<template>
    <div class="filter-not-full-box-container">
     
         <img class="filter-not-full-icon" src="/icons/general_icons/warning.svg" alt="not_filter_full.icon">
 
     
     <p class="messages"> {{ responseStatusMessages }} </p> 
    </div>
 
 </template>
 
 <script>
 export default {
 props:{
   responseStatusMessages:{
       type:String,
       default:''
   }
 }
 }
 </script>
 
 <style scoped lang="scss">
 
 .filter-not-full-box-container {
     width: 100%;
     min-width: 12vw;
     height: 100%;
     display: flex;
     flex-flow: row nowrap;
     align-items: center;
     justify-content: center;
     padding: 1vw;
     gap: 3%;
     border: 1px dotted #e14242d8;
     border-radius: 8px;


 
 }
 
 .filter-not-full-icon {
 height: 2vw;
 width: 2vw;
 
 
 
 }
 
 .messages {
    width: max-content;
     font-size: .7vw;
     font-weight: 550;
     color: #0d0f27b9;
 }
 </style>